import React from 'react';
import {Button} from 'antd';
import FeatureGrid from '../../components/site/FeatureGrid';
import HeroSection from '../../components/site/HeroSection';
import RiskGuardSection from '../../components/site/RiskGuardSection';
import SectionTitle from '../../components/site/SectionTitle';
import {useWaitlist} from '../../components/site/WaitlistModal';
import {useSiteContent} from './siteContent';
import styles from './SitePages.module.css';

const ProgressPage: React.FC = () => {
    const {resources, waitlistCta} = useSiteContent();
    const {openWaitlist} = useWaitlist();

    return (
        <div className={styles.page}>
            <section className={styles.section}>
                <HeroSection
                    description={resources.riskHero.description}
                    eyebrow={resources.riskHero.eyebrow}
                    metrics={resources.riskMetrics}
                    panelDescription={resources.riskHero.panelDescription}
                    panelLabel={resources.riskHero.panelLabel}
                    panelTitle={resources.riskHero.panelTitle}
                    title={resources.riskHero.title}
                />
            </section>

            <section className={styles.section}>
                <SectionTitle
                    description={resources.riskSections.guard.description}
                    eyebrow={resources.riskSections.guard.eyebrow}
                    title={resources.riskSections.guard.title}
                />
                <div className="site-section"/>
                <RiskGuardSection items={resources.riskGuardItems}/>
            </section>

            <section className={styles.section}>
                <SectionTitle
                    description={resources.riskSections.matrix.description}
                    eyebrow={resources.riskSections.matrix.eyebrow}
                    title={resources.riskSections.matrix.title}
                />
                <div className="site-section"/>
                <FeatureGrid items={resources.riskMatrixItems}/>
            </section>

            <section className={styles.section}>
                <article className={`site-card ${styles.ctaPanel}`}>
                    <div>
                        <span className="site-eyebrow">{resources.riskCta.eyebrow}</span>
                        <h3>{resources.riskCta.title}</h3>
                        <p>{resources.riskCta.description}</p>
                    </div>
                    <div className={styles.ctaActions}>
                        <Button size="large" type="primary" onClick={openWaitlist}
                                style={{height: 48, paddingInline: 32, fontSize: 16}}>
                            {waitlistCta.label}
                        </Button>
                    </div>
                </article>
            </section>
        </div>
    );
};

export default ProgressPage;
